module.exports = __webpack_public_path__ + "d0420757545fb9b3d31db908e853a7a1.jpg";